module.exports = __webpack_public_path__ + "img/new_home-banner.b896f69d.png";